import { useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from '~/helpers/hotKeys';

type Props = {
    changeToPrevious: () => void;
    changeToNext: () => void;
};

export default function useVariationsShortcuts({ changeToPrevious, changeToNext }: Props) {
    const handleChange = (event) => {
        if (isInteractiveElement(event) || isCtrlKey(event)) {
            return;
        }

        if (event.shiftKey) {
            if (['ArrowUp', 'PageUp', 'PgUp'].includes(event.code)) {
                event.preventDefault();

                changeToPrevious && changeToPrevious();
            }

            if (['ArrowDown', 'PageDown', 'PgDn'].includes(event.code)) {
                event.preventDefault();

                changeToNext && changeToNext();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleChange);

        return () => {
            document.removeEventListener('keydown', handleChange);
        };
    }, [handleChange]);
}
